import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFigma32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFigma32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.513 12.242a3.914 3.914 0 0 1 2.134-7.195h6.706a3.914 3.914 0 0 1 2.134 7.195 3.914 3.914 0 0 1-2.134 7.195h-.072a3.9 3.9 0 0 1-2.649-1.033v3.646c0 2.186-1.79 3.95-3.967 3.95-2.157 0-3.932-1.748-3.932-3.914a3.91 3.91 0 0 1 1.78-3.281 3.91 3.91 0 0 1-1.78-3.282 3.91 3.91 0 0 1 1.78-3.281m6.12 3.281a2.65 2.65 0 0 0 2.649 2.65h.07a2.65 2.65 0 0 0 0-5.299h-.07a2.65 2.65 0 0 0-2.65 2.65m-1.265-2.649h-2.72a2.65 2.65 0 0 0-.01 5.298h2.73zm-2.72 6.563h-.01a2.65 2.65 0 0 0-2.64 2.65c0 1.458 1.2 2.648 2.667 2.648 1.487 0 2.703-1.206 2.703-2.685v-2.613zm2.72-7.828h-2.72a2.65 2.65 0 1 1 0-5.298h2.72zm3.985 0h-2.72V6.311h2.72a2.65 2.65 0 1 1 0 5.298"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFigma32);
